<script setup lang="ts">
import ModalV2 from '~/components/common/ModalV2.vue'
import HSForm from '~/components/forms/HSForm.vue'
import Button from '~/components/common/Button.vue'
import UserCheckIcon from '~/assets/icons/user-check-01.svg'
import { useModalStore } from '~/stores/modal'
import { createAccountStore } from '~/stores/createAccount'

const MODAL_NAME = 'createAccount'

const createAccount = createAccountStore()
const { formId } = storeToRefs(createAccount)

const modalStore = useModalStore()
const { hubspotCreateAccountFormId } = useRuntimeConfig().public

const isSubmitted = ref(false)
const isSubmitting = ref(false)
const isOpen = computed(() => modalStore.getModal(MODAL_NAME))

const close = () => {
  modalStore.close(MODAL_NAME)

  createAccount.setFormId(hubspotCreateAccountFormId)
  if (!isSubmitted.value) modalStore.open('signIn')
}

const onReadyForm = () => {
  isSubmitted.value = false
  isSubmitting.value = false
}

const onSubmitted = () => {
  isSubmitted.value = true
  isSubmitting.value = false
}
const onBeforeSubmit = () => {
  isSubmitting.value = true
}
</script>

<template>
  <ModalV2
    data-testid="create-account-modal"
    modal-classes="max-w-[330px] md:max-w-[788px] h-fit max-h-[85vh] min-h-[300px] md:max-h-[740px] !p-0 bg-white"
    :name="MODAL_NAME"
    :is-open="isOpen"
    @close="close"
  >
    <div
      class="flex flex-col md:flex-row"
      :class="isSubmitted ? 'min-h-[313px] h-full md:h-[313px]' : ''"
    >
      <HSForm
        data-testid="create-account-form"
        class="create-account md:overflow-y-auto md:order-none order-1"
        :class="isSubmitting ? '' : 'p-5 pt-14 md:px-12 md:pt-10 md:pb-5'"
        :form-id="formId"
        @on-ready="onReadyForm"
        @on-before-submit="onBeforeSubmit"
        @on-submitted="onSubmitted"
      >
        <template #success>
          <div class="flex flex-col justify-center items-center">
            <UserCheckIcon class="w-20 h-20 text-semantic-good" />
            <p class="mt-4 font-semibold text-center text-h6 flex flex-col">
              <span>Thank you for your submission,</span>
              <span>you will receive an email from us shortly.</span>
            </p>
            <Button
              class="mt-13 w-full md:w-full"
              variant="primary"
              @click="close"
            >
              Close
            </Button>
          </div>
        </template>

        <template #footer>
          <Button
            v-if="!isSubmitting"
            data-testid="create-account-back-button"
            class="mt-2 w-full flex-shrink-0 !text-sm"
            variant="clean"
            @click="close"
          >
            Back
          </Button>
        </template>
      </HSForm>
      <div
        class="relative order-none h-40 md:h-full md:w-[262px] flex-shrink-0 w-full md:block hidden"
      >
        <img
          data-testid="create-account-image"
          class="object-cover w-full h-40 md:h-full"
          src="https://res.cloudinary.com/benchmarkminerals/image/upload/v1744056312/assets/login/recortada_qfq6do.png"
          alt="Create Account"
        />
      </div>
    </div>
  </ModalV2>
</template>

<style>
@media (max-width: 768px) {
  .create-account .bm-custom-form .form-columns-2 {
    flex-direction: column !important;
  }

  .create-account .bm-custom-form .form-columns-2 .hs-form-field {
    width: 100% !important;
  }
}
</style>
